import React, { memo } from 'react';
import PropTypes from 'prop-types';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import isNil from 'ramda/src/isNil';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import EditDropdown from '@components/EditDropdown';
import { CardType, LibraryModuleMenu } from '~/services/config';
import { removeAssign } from '~/services/util';

const Module = ({ userRole, name, thumbnail, type, description, tracks, courses, assigned, published, onPreview, onSelect }) => {
    const TYPE = isNil(type) ? null : find(propEq('id', type), CardType);
    const options = removeAssign(LibraryModuleMenu[userRole], published);
    return (
        <div className="library-module-card p-0">
            <div className="lib-content flex-row">
                <div className="d-flex d-flex-1 cursor-pointer w-90" onClick={() => onPreview()}>
                    <Thumbnail source={thumbnail} />
                    <div className="module-content ai-start">
                        <div className="d-flex-5 mb-0 cursor-pointer">
                            {isNil(TYPE) ? (
                                <>
                                    <p className="dsl-b16 text-400 text-truncate word-break pb-0 mb-0">{name}</p>
                                    <div className="dsl-b16 text-truncate word-break mb-0" dangerouslySetInnerHTML={{ __html: description }} />
                                </>
                            ) : (
                                <>
                                    <div className="d-flex mb-1">
                                        <Icon name={`${TYPE.alias} me-2`} size={14} color="#676767" />
                                        <span className="dsl-m12 text-400">{TYPE.label}</span>
                                    </div>
                                    <p className="dsl-b16 text-400 pb-0 mb-1 text-wrap-ssm">{name}</p>
                                    <p className="dsl-b16 text-truncate mb-0 course-description" dangerouslySetInnerHTML={{ __html: description }} />
                                </>
                            )}
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-4 mb-0 text-nowrap count">{tracks || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-4 mb-0 text-nowrap count">{courses || 0}</p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-4 mb-0 text-nowrap count">{assigned || 0}</p>
                        </div>
                    </div>
                </div>
                <div className="edit">
                    <EditDropdown options={options} onChange={onSelect} />
                </div>
            </div>
        </div>
    );
};

Module.propTypes = {
    userRole: PropTypes.number,
    name: PropTypes.string,
    thumbnail: PropTypes.string,
    type: PropTypes.number,
    assigned: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onPreview: PropTypes.func,
    onSelect: PropTypes.func,
};

Module.defaultProps = {
    userRole: 1,
    name: '',
    thumbnail: '',
    type: 0,
    assigned: 0,
    onPreview: () => {},
    onSelect: () => {},
};

export default memo(Module);
